<template lang="html">

  <section class="login">
    <div class="pt-5 wrapper d-flex align-items-center auth login-full-bg" style="height: 100%">
      <div class="row w-100">
        <div class="col-lg-5 col-md-4 mx-auto">
          <div class="auth-form-dark bg-dark text-left p-5" >
            <h2>{{$t('Login')}}</h2>
            <h4 class="font-weight-light">{{$t('Welcome to')}} Nordtech</h4>
            <form class="pt-5">
              <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 120px;">
                <b-spinner
                  variant="secondary"
                ></b-spinner>
              </div>
              <b-form v-if="!forgotForm">
                <div class="form-group">
                  <label>{{$t('Username/Email')}}</label>
                  <b-form-input v-on:keyup.enter="login" type="email" v-model="email" aria-describedby="emailHelp"></b-form-input>
                  <i class="mdi mdi-account"></i>
                </div>
                <div class="form-group">
                  <label >{{$t('Password')}}</label>
                  <b-form-input v-on:keyup.enter="login" :type="passwordFieldType" v-model="password"></b-form-input>
                  <!--<input type="password" class="form-control" v-model="password" placeholder="">-->
                  <i class="mdi mdi-eye" @click="switchVisibility"></i>
                </div>
                <div class="form-group">
                  <b-alert :variant="variant"
                           :show="error"
                           dismissible
                           @dismissed="error = false">{{errorMessage}}</b-alert>
                </div>
                <div class="mt-5">
                  <!--<a class="btn btn-block btn-light btn-lg font-weight-medium" @click="login">Login</a>-->
                  <b-button v-on:click="login" class="btn btn-block btn-light btn-lg font-weight-medium">{{$t('Login')}}</b-button>
                </div>
                <div class="mt-3 text-center">
                  <a @click="forgotPassword"  style="cursor: pointer;" class="auth-link text-white">{{$t('Forgot password?')}}</a>
                </div>
                </b-form>
              <b-form v-else>
                <div class="form-group">
                  <label>{{$t('Your current account email')}}:</label>
                  <b-form-input v-on:keyup.enter="login" type="email" v-model="forgotEmail" aria-describedby="emailHelp"></b-form-input>
                  <i class="mdi mdi-account"></i>
                </div>
                <div class="form-group">
                  <b-alert :variant="forgotVariant"
                           :show="forgotError"
                           dismissible
                           @dismissed="error = false">{{forgotErrorMessage}}</b-alert>
                </div>
                <div class="mt-5">
                  <!--<a class="btn btn-block btn-light btn-lg font-weight-medium" @click="login">Login</a>-->
                  <b-button v-on:click="sendForgotEmail" class="btn btn-block btn-light btn-lg font-weight-medium">{{$t('Submit')}}</b-button>
                </div>
              </b-form>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">
export default {
  name: 'login',
  data () {
    return {
      /* eslint-disable */
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      loading: false,
      variant: null,
      forgotErrorMessage: null,
      forgotVariant: null,
      forgotError: false,
      forgotForm: false,
      passwordFieldType: 'password',
      forgotEmail: null,
      email: null,
      password: null,
      errorMessage: null,
      error: false
    }
  },
  mounted () {
    if (this.$store.state.user.loggedIn) {
      // this.$router.push(name: '')
    }
  },
  methods: {
    switchVisibility () {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    forgotPassword () {
      this.forgotForm = true
    },
    sendForgotEmail () {
      if (this.forgotEmail == null) {
        this.forgotErrorMessage = this.$t('Email is required')
        this.forgotError = true
      }
      var self = this
      this.$firebase.auth().sendPasswordResetEmail(self.forgotEmail).then(function () {
        self.$swal({
          title: self.$t('Forgot email Sent!'),
          type: 'success',
          timer: 1500,
          showConfirmButton: false
        }).then(function (result) {
          self.resetForgotForm()
          self.forgotForm = false
        })
      }).catch(function (error) {
        console.log(error)
        self.forgotError = true
        self.forgotErrorMessage = error.message
        self.forgotVariant = 'danger'
      })
    },
    resetForgotForm () {
      self.forgotError = null
      self.forgotErrorMessage = null
      self.forgotVariant = null
      self.forgotEmail = null
    },
    isEmailValid: function(email) {
      return this.reg.test(email);
    },
    async login () {
      this.loading = true
      let self = this
      self.error = false
      var email = ""

      if (!this.isEmailValid(this.email)) {
        email = this.email + '@yescheflabel.com'
      } else {
        email = this.email
      }

      await this.$firebase.auth().signInWithEmailAndPassword(email, this.password)
        .then(function (user) {
          self.loading = false
          // console.log('user', user)
          self.variant = 'success'
          self.errorMessage = self.$t('Successfully logged in!')
          self.$store.state.user.loggedIn = true
          // Save user and get user details
        })
        .catch(function (error) {
          console.log(error)
          self.loading = false
          self.error = true
          self.variant = 'danger'
          self.errorMessage = error.message
          // Handle Errors here.
          // var errorCode = error.code;
          // var errorMessage = error.message;
        })
    }

  }
}
</script>

<style lang="scss">
.login {
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
  //  -webkit-text-fill-color: #ffffff !important;
    font-size: 15px !important;
  }
}

.row.w-100 {
  margin-left: unset;
  margin-right: unset;
}

</style>



// WEBPACK FOOTER //
// src/views/pages/login.vue